import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { ParcelNumberPageComponent } from './parcel-number.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: ParcelNumberPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class ParcelNumberPageRoutingModule {}
